// extracted by mini-css-extract-plugin
export default {"background_img":"styles_background_img__qSKKS","win_img":"styles_win_img__vAz4Z","lose_img":"styles_lose_img__MDl8C","boom_img":"styles_boom_img__BIfEj"};